<template lang="pug">
span.commentary-detail-level-dots(
  :title="`${i18n.t('Taxonomy.LevelOfDetail')}: ${name}`"
)
  VIcon.mr-1(
    v-for="i in length"
    :key="i"
    :icon="i > value ? mdiCircleOutline : mdiCircle"
    :color="dark ? 'primary-c050' : 'primary-c600'"
    size="small"
  )
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { mdiCircle, mdiCircleOutline } from "@mdi/js";
import { useDarkMode } from "~/composables/useDarkMode";

const i18n = useI18n();
const dark = useDarkMode();

interface Props {
  value: number;
  name: string;
  length: number;
}

const props = withDefaults(defineProps<Props>(), {});
</script>
